import React from "react";
import PropTypes from "prop-types";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";

import { getCardIcon } from "../../../../utils/BinUtils";

const group = number => {
  const numbersArray = [];
  for (let i = 0; i < number.length; i += 4) {
    numbersArray.push(number.substr(i, 4));
  }
  return numbersArray.join(" ");
};

const trim = number => {
  return number.replace(/\s+/g, "");
};

const format = number => {
  return group(trim(number));
};

const reformat = e => {
  const { value, selectionEnd } = e.target;
  const numbers = trim(value);

  const rightCharsCount = value.length - selectionEnd;
  const formattedValue = group(numbers);
  let newPosition = Math.max(formattedValue.length - rightCharsCount, 0);
  if (formattedValue.length > 19) newPosition -= 1;

  const input = e.nativeEvent.target;
  setTimeout(() => {
    input.setSelectionRange(newPosition, newPosition);
  }, 0);

  return formattedValue.substr(0, 19);
};

const handleChange = (event, callback) => {
  const cardNumber = trim(event.target.value);
  if (!/^\d*$/.test(cardNumber)) {
    return;
  }

  const newValue = reformat(event);
  // eslint-disable-next-line no-param-reassign
  event.target.value = newValue;
  callback(event);
};

const CardInput = ({
  showError,
  errorMsg,
  value,
  onBlur,
  onChange,
  className
}) => {
  const cardIcon = getCardIcon(value);
  return (
    <TextField
      className={className}
      error={showError}
      helperText={errorMsg}
      value={format(value)}
      onChange={e => handleChange(e, onChange)}
      onBlur={onBlur}
      label="Card number"
      fullWidth
      autoFocus
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <img src={cardIcon} alt="card-logo" style={{ width: 25 }} />
          </InputAdornment>
        )
      }}
    />
  );
};

CardInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  showError: PropTypes.bool,
  errorMsg: PropTypes.string,
  className: PropTypes.string
};

CardInput.defaultProps = {
  value: "",
  onBlur: () => {},
  showError: false,
  errorMsg: undefined,
  className: undefined
};

export default CardInput;
